import type { CandidateRateDiscount } from '@axiom/validation';

export const CandidateRateDiscountUtil = {
  getPercentage: (discount: CandidateRateDiscount | null) => {
    return discount === null
      ? null
      : `${Math.floor((1 - discount.multiple) * 100)}%`;
  },
};
